// extracted by mini-css-extract-plugin
export var container = "_60-1";
export var cornerButtonContainer = "_60-5";
export var disabled = "_60-2";
export var fileContainer = "_60-4";
export var hiddenInput = "_60-3";
export var widthContainer = "_60-0";